import $ from 'jquery';

const refreshToken = {
    mounted: function () {
        window.setInterval(() => {
            this.refreshToken();
        }, 900000);
    },
    methods: {
        refreshToken () {
            $.ajax({
                url: '/refresh-token',
                context: this,
                method: 'GET',
                success: function (data) {
                    this.tokenVal = data.token;
                }
            });
        }
    }
};

export default refreshToken;
